import { createSelector } from '@reduxjs/toolkit';
import { selectSuburbanFloorsValue } from './selectSuburbanFloorsValue';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: '1', value: 1 },
  { label: '2 и более', value: 2 },
];

export const selectSuburbanFloorsFilter = createSelector(selectSuburbanFloorsValue, value => ({
  label: 'Этажей в доме',
  value: [value],
  options: OPTIONS,
}));
